import { Icon } from '@branch-messenger/willow-ui'
import {
  CreditCard02,
  HelpCircle,
  LogOut01,
  TaxDocument,
  UserCircle,
} from '@branch-messenger/willow-ui/icons'
import { useQuery } from '@tanstack/react-query'
import { linkOptions } from '@tanstack/react-router'

import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownSeparator,
} from '@/components/dropdown-menu'
import { DropdownMenuGroup } from '@/components/dropdown-menu/styles'
import { supportUrl } from '@/lib/urls'
import { useLogout } from '@/queries/auth'
import { taxWorkerDetailsQueryOptions } from '@/queries/tax'
import { type FileRoutesByTo } from '@/routeTree.gen'
import { useOrg } from '@/selectors/organization'

import { AccountDropdownUserInfo } from './AccountDropdownUserInfo'

export type ValidRoutes = keyof FileRoutesByTo

const menuItems = linkOptions([
  {
    to: '/account/personalInfo',
    icon: UserCircle,
    title: 'Account Info',
  },
  {
    to: '/account/connectedDebitCards',
    icon: CreditCard02,
    title: 'Connected Debit Cards',
  },
  {
    to: '/account/taxDetails',
    icon: TaxDocument,
    title: 'Taxes',
  },
])

export const AccountDropdown = () => {
  const logout = useLogout()
  const isAccountRoute = location.pathname.includes('/account')
  const { data: taxDetails } = useQuery(taxWorkerDetailsQueryOptions)
  const {
    data: { onboardingRequireW9Collection },
  } = useOrg()

  const filteredMenuItems = menuItems.filter(item => {
    if (item.to === '/account/taxDetails') {
      return !!taxDetails && onboardingRequireW9Collection
    }
    return true
  })

  const handleLogout = () => logout.mutate()

  return (
    <DropdownMenu
      trigger={<DropdownMenuTrigger Icon={UserCircle} />}
      showArrow={false}
      constrainHeight={false}
    >
      {isAccountRoute && (
        <>
          <AccountDropdownUserInfo />
          <DropdownSeparator />
          <DropdownMenuGroup>
            {filteredMenuItems.map(({ icon, ...item }) => (
              <DropdownMenuItem
                key={item.to}
                iconLeft={<Icon Icon={icon} />}
                showArrowRight={false}
                titleSize="xs"
                {...item}
              />
            ))}
          </DropdownMenuGroup>
          <DropdownSeparator />
        </>
      )}
      <DropdownMenuGroup>
        <DropdownMenuItem
          href={supportUrl}
          target="_blank"
          rel="noreferrer"
          iconLeft={<Icon Icon={HelpCircle} />}
          showArrowRight={false}
          title={'Help Center'}
          titleSize="xs"
        />
        {isAccountRoute && (
          <DropdownMenuItem
            onClick={handleLogout}
            iconLeft={<Icon Icon={LogOut01} />}
            showArrowRight={false}
            title={'Sign Out'}
            titleSize="xs"
          />
        )}
      </DropdownMenuGroup>
    </DropdownMenu>
  )
}
